import { GzzFamilyMember } from "../general/GzzFamilyMember";

export class SrvAdditionalInfo {

  DeceasedBirthCountry: string;
  DeceasedCityInIsrael: string;
  DeceasedMaidenLastName: string;
  DeceasedMaidenFirstName: string;
  DeceasedFatherPrevName: string;
  DeceasedFatherBirthCountry: string;
  WasTreatedInTransitCamp: boolean;
  CampName: string;
  CampCountry: string;
  TreatedFamilyMembers: GzzFamilyMember[];
  PersonalLetter: string;

  constructor(data: SrvAdditionalInfo) {

    Object.assign(this, data);

    if (data) {

      if (data.TreatedFamilyMembers) {
        for (var i = 0; i < data.TreatedFamilyMembers.length; i++) {
          this.TreatedFamilyMembers[i] = new GzzFamilyMember(data.TreatedFamilyMembers[i]);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/Survivors/SrvAdditionalInfo.ts